import {
    FieldErrors,
    FieldValues,
    Path,
    RegisterOptions,
    UseFormRegister,
} from 'react-hook-form';
import { get } from 'lodash';
import MultiSelectCheck, {
    ISelectedItem,
    CustomSelectsOption,
    SelectVariant,
} from './MultiSelectCheck';


export type FormMultiSelectProps<TFormValues extends FieldValues> = {
    name: Path<TFormValues>;
    options: CustomSelectsOption[];
    onSelect: (selectedItems: ISelectedItem) => void;
    selectedItems: ISelectedItem[];
    label: string;
    disabled?: boolean;
    className?: string;
    classNameInput?: string;
    bgSelect?: string;
    register?: UseFormRegister<TFormValues>;
    rules?: RegisterOptions<TFormValues>;
    errors?: FieldErrors<TFormValues>;
    isRequired?: boolean;
    variant: SelectVariant;
};

export const FormMultiSelect = <TFormValues extends FieldValues>({
    name,
    options,
    onSelect,
    selectedItems,
    label,
    disabled,
    className = '',
    classNameInput = '',
    register,
    rules,
    errors,
    isRequired,
    variant
}: FormMultiSelectProps<TFormValues>): JSX.Element => {

    const rootError = get(errors, name) as { message?: string } | undefined;
    const hasError = !!rootError?.message;

    return (
        <div className={`w-full ${className}`} aria-live="polite">
            <MultiSelectCheck
                options={options}
                onSelect={onSelect}
                selectedItems={selectedItems}
                label={label}
                disabled={disabled}
                classNameInput={classNameInput}
                isRequired={isRequired}
                variant={variant}
                {...(register && register(name, rules))}
            />
            {hasError && (
                <p className="mt-1 text-bsmall block text-[#BA1A1A]">
                    {rootError?.message}
                </p>
            )}
        </div>
    );
};